import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const formActions = require('react-redux-form').actions;
import { formatText } from 'core/i18n';
import { recordEventCustomOnly } from 'utilities/uTagging';

import CheckBox from '../../../components/checkBox/checkBox';
import checkIcon from '../../assets/images/vedacom-document-checked.svg';
import LendingsFast from '../../assets/images/ares-lendings-fast.svg';
import { InfoTooltip } from 'components/tooltip/tooltip';

import './vedacom.scss';
import VedacomModal from './VedacomModal';

class Vedacom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showVedacomModal: false,
        };
    }

    readAgainVedacomEvent = e => {
        e.preventDefault();
        if (this.props?.userProfile?.vedacomConfirmedAcceptance) {
            recordEventCustomOnly({
                accionEvento: 'autorizacion consulta de datos TGSS',
                categoriaEvento: 'interaccion en datos personales',
                etiquetaEvento: 'volver a leer',
            });
            this.setState({ showVedacomModal: true });
        }
    };

    render() {
        const { userProfile, formActions, onChange = true } = this.props;
        const { optionalVedacomCheck, vedacomConfirmedAcceptance } = userProfile;
        return (
            <div className="vedacom">
                <div className="vedacom__image-section">
                    <img className="vedacom__image" src={LendingsFast} alt="Lendings fast" />
                    <div className="vedacom__section">
                        <div className="vedacom__text-container">
                            <h5>{formatText('vedacon-title_ares')}</h5>
                            <p>
                                {formatText('vedacon-text1_ares')}
                                <InfoTooltip text={formatText('vedacon-tooltip')} />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="vedacom__check">
                    <div className="vedacom__section">
                        <CheckBox
                            profileModel="userProfile.optionalVedacomCheck"
                            checkBoxList={[
                                {
                                    label: formatText('vedacon-check_text_ares'),
                                    model: 'userProfile.optionalVedacomCheck',
                                },
                            ]}
                            userProfile={userProfile}
                            description={formatText('vedacon-text2_ares')}
                            boldLabel={true}
                            onChange={onChange}
                            {...this.props}
                        />
                    </div>

                    {optionalVedacomCheck && (
                        <div className="vedacom__section">
                            <div className="vedacom__text-container">
                                {!vedacomConfirmedAcceptance && <h5>{formatText('vedacon-subtitle_ares')}</h5>}
                                <div
                                    className="vedacom__document"
                                    confirmedAcceptance={`${vedacomConfirmedAcceptance}`}
                                >
                                    {!vedacomConfirmedAcceptance && <p>{formatText('vedacon-text3_ares')}</p>}
                                    {vedacomConfirmedAcceptance && (
                                        <a onClick={this.readAgainVedacomEvent}>
                                            <img src={checkIcon} alt="Checked" />
                                            {formatText('vedacon-docname_ares')}
                                        </a>
                                    )}
                                    <button
                                        className={`form__button ${
                                            vedacomConfirmedAcceptance
                                                ? 'form__button-transparent'
                                                : 'form__button-primaryB'
                                        }`}
                                        onClick={e => {
                                            e.preventDefault();
                                            this.setState({ showVedacomModal: true });
                                            recordEventCustomOnly({
                                                accionEvento: 'autorizacion consulta de datos TGSS',
                                                categoriaEvento: 'interaccion en datos personales',
                                                etiquetaEvento: 'leer',
                                            });
                                        }}
                                    >
                                        {vedacomConfirmedAcceptance
                                            ? formatText('vedacon-read_ares')
                                            : formatText('vedacon-button_ares')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <VedacomModal
                    showModal={this.state.showVedacomModal}
                    handleClose={() => this.setState({ showVedacomModal: false })}
                    confirmAcceptance={e => {
                        e.preventDefault();
                        formActions.change('userProfile.vedacomConfirmedAcceptance', true);
                        this.setState({ showVedacomModal: false });
                    }}
                    isAccepted={vedacomConfirmedAcceptance}
                />
            </div>
        );
    }
}

export default connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(Vedacom);
